<template>
  <modal ref="modal" display="inline">
    <template #trigger>
      <a class="cookies-link" tabindex="0" @click.stop="clickHandler" @keydown="keyDownHandler">
        Cookies
      </a>
    </template>
    <template #title>
      <h4>Cookies</h4>
    </template>
    <template #content>
      <p>
        We store data so that you can sign in and to improve the performance of the site.
      </p>
      <padding direction="top"/>
      <p>
        You can opt out of non-essential data storage, which may impact site performance.
      </p>
      <padding direction="top" size="medium-large"/>
      <checkbox-input v-model="cookieDecision" label="Allow non-essential data storage" name="cookieDecision"/>
    </template>
  </modal>
</template>

<script lang="js">
import { mapActions, mapGetters } from 'vuex'
import Modal from '../Modal'
import Padding from './Padding'
import CheckboxInput from '../Form/CheckboxInput'
import enterKeyPressed from '../../utils/enterKeyPressed'

export default {
  name: 'CookiesModal',
  components: { CheckboxInput, Padding, Modal },
  computed: {
    ...mapGetters(
      {
        decision: 'cookieConsent/decision',
      },
    ),
    cookieDecision: {
      get() {
        return this.decision
      },
      set(value) {
        this.setDecision({ decision: value })
      },
    },
  },
  methods: {
    ...mapActions(
      {
        setDecision: 'cookieConsent/setDecision',
      },
    ),
    keyDownHandler(event) {
      if (enterKeyPressed(event)) {
        this.clickHandler()
      }
    },
    clickHandler() {
      this.$refs.modal.openModal()
    },
  },
}
</script>
